import styled from 'styled-components';

import colors from '$/assets/theme/colors';

const StyledHint = styled.div`
  display: flex;
  align-items: center;

  a {
    color: ${colors.grey5};
    text-decoration: underline;
  }
`;

export default StyledHint;
